<template>
  <v-dialog v-model="dialogLocal" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Скопировать трайл <strong>{{ trial.name }}</strong></span>
      </v-card-title>
      <v-card-text>
        <vue-form :state="formState" @submit.prevent="submit">
          <v-container grid-list-md class="pt-0">
            <v-layout wrap>

              <v-flex xs12>
                <validate>
                  <v-text-field
                    v-model.trim="newTrialName"
                    name="newTrialName"
                    label="Новое название трайла"
                    maxlength="40"
                    hide-details
                    required
                  />
                  <field-messages
                    name="newTrialName"
                  >
                    <small class="error--text" slot="required">
                      Обязательное поле
                    </small>
                    <small class="error--text" slot="maxlength">
                      Слишком длинное поле
                    </small>
                  </field-messages>
                </validate>
              </v-flex>

            </v-layout>
          </v-container>
          <v-container fluid grid-list-xl>
            <v-layout wrap align-top justify-end>
              <v-btn color="warning" flat @click="close">
                Закрыть
              </v-btn>
              <v-btn type="submit" color="success" :disabled="formState.$invalid || isLoading">
                Скопировать трайл
              </v-btn>
            </v-layout>
          </v-container>
        </vue-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import { mapActions } from 'vuex';
import STORE from '../../../store/STORE';

const copyMethod = STORE.modules.trial.actions.copyTrial;

export default {
  name: 'copyTrialPopup',
  props: {
    dialog: {
      type: Boolean,
      default: () => false,
    },
    trial: {
      type: Object,
    }
  },
  data() {
    return {
      newTrialName: '',
      isLoading: false,
      formState: {}
    };
  },
  watch: {
    dialogLocal() {
      this.newTrialName = `${this.trial.name.trim()} copy`;
      this.formState._validate();
    }
  },
  computed: {
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit('update:dialog', val);
      },
    },
  },
  methods: {
    ...mapActions('trialUtils', [copyMethod]),

    close() {
      this.formState._reset();
      this.dialogLocal = false;
    },
    async submit() {
      if (this.formState.$invalid) return;

      this.isLoading = true;
      try {
        let createdTrial = await this[copyMethod]({
          trial_id: this.trial.id,
          newTrialName: this.newTrialName
        });
        this.close();
        window.open(`/trial/${createdTrial.id}`, '_blank');
      } catch {
        //
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
